import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.css']
})
export class AboutusComponent implements OnInit {

  public sectionTitle:string = "Chi siamo";
  public sectionDescription:string = "Siamo appassionati di vela come te, animati dallo spirito di creare una comunità di amanti di questo sport e del mare.";


  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landingpage/sections/aboutus/aboutus.component.ts